import React, {useState} from 'react';
import {ERROR, UNIT} from '@di-shared/const';
import DailyLineGraph from '@di-shared/features/common/DailyLineGrpah';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

export interface EnergyPowerDailyGraphProps {
  data: Array<{
    score: number;
    scoreDate: Date;
  }>;
  error?: boolean;
}

export default function EnergyPowerDailyGraph({data, error = false}: EnergyPowerDailyGraphProps) {
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const [selectedDataIndex, setSelectedDataIndex] = useState<number>(data.length - 1);

  function getTooltipText(selectedDataIndex: number) {
    const selectedScoreDate = data[selectedDataIndex].scoreDate;
    return error
      ? `${CldrDatetimeFormatter.format(selectedScoreDate, 'MMMd')}┃${ERROR.DASH}${UNIT.KWH}`
      : `${CldrDatetimeFormatter.format(selectedScoreDate, 'MMMd')}┃${data[selectedDataIndex].score}${UNIT.KWH}`;
  }

  return (
    <DailyLineGraph
      data={data}
      labels={data.map((dataItem) => dataItem.scoreDate)}
      options={{
        tooltip: {
          isShow: true,
          tooltipText: getTooltipText(selectedDataIndex),
        },
      }}
      interactions={{
        selectedDataIndex,
        onUpdateSelectedDataIndex: setSelectedDataIndex,
      }}
    />
  );
}
